import type { HeroOverlayProps } from "./types";

const normalizedBasePath = (process.env.NEXT_PUBLIC_BASE_PATH ?? "").replace(
  /\/$/,
  ""
);
const heroImagePath = `${normalizedBasePath}/images/heroes/`;

export const HERO_OVERLAY_BACKGROUND_IMAGE_TOKENS: Record<string, string> = {
  "fiber-lines-desktop-hero": `${heroImagePath}fiber-lines-desktop.jpg`,
  "fiber-lines-mobile-hero": `${heroImagePath}fiber-lines-mobile.jpg`,
  "group-park-gradient-hero": `${heroImagePath}group-park-gradient-fiber-lines.jpg`,
  "group-park-hero": `${heroImagePath}group-park-fiber-lines.jpg`,
  "group-park-hero-mobile": `${heroImagePath}group-park-fiber-lines-mobile.jpg`,
  "man-on-computer-hero": `${heroImagePath}man-on-computer.jpg`,
  "man-on-computer-hero-mobile": `${heroImagePath}man-on-computer-mobile.jpg`,
};

const withBase = (path: string) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (!normalizedBasePath) return path;
  if (path.startsWith(normalizedBasePath) || path.startsWith("/_next/")) {
    return path;
  }
  return `${normalizedBasePath}${path}`;
};

const resolveBackgroundImagePath = (path?: string) => {
  if (!path) return "";

  const normalized = path.trim().replace(/^['"]|['"]$/g, "");
  if (!normalized) return "";

  const mappedImage =
    HERO_OVERLAY_BACKGROUND_IMAGE_TOKENS[normalized.toLowerCase()];
  if (mappedImage) {
    return mappedImage;
  }

  if (normalized.startsWith("/")) {
    return withBase(normalized);
  }

  if (normalized.startsWith("http://") || normalized.startsWith("https://")) {
    return normalized;
  }

  return `${heroImagePath}${normalized}`;
};

export const resolveHeroOverlayBackgrounds = (
  backgroundImages: HeroOverlayProps["backgroundImages"]
) => {
  const desktop = resolveBackgroundImagePath(backgroundImages.desktop);
  const tablet = resolveBackgroundImagePath(backgroundImages.tablet) || desktop;
  const mobile = resolveBackgroundImagePath(backgroundImages.mobile) || desktop;
  const alt = backgroundImages.alt?.trim() || "";

  return {
    desktop,
    tablet,
    mobile,
    alt,
    hasBackgroundImages: !!desktop,
  };
};
